import {B} from "../build";

export function isInDisabledAppMode(): boolean {
    return Boolean(B.DISABLE_APPLICATION);
}
